import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'quote-step9',
  templateUrl: 'quote-step9.component.html',
  styleUrls: ['quote-step9.component.css'],
})
export class QuoteStep9Component {
  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();
  
  constructor() {}

  nextStep(stepNumber?: number): void {
		 this.onNextStep.emit(stepNumber ?? this.currentStep);
	}

  prevStep(stepNumber?: number): void {
    this.onPrevStep.emit(stepNumber ?? this.currentStep);
 }
}
